import {
  action,
  IObservableArray,
  makeObservable,
  observable,
  toJS,
} from "mobx";
import { IStoreElement } from "types/store";
import { ExtendedNextPageContext } from "types/app";
import { isCheckCategoryVersion } from "helpers/category";

function toFlatObject(categories = [], acc = {}, property = "path") {
  categories.forEach(c => {
    if (c && c[property]) {
      acc[c[property]] = c;
      if (c.children && c.children.length) {
        toFlatObject(c.children, acc, property);
      }
    }
  });

  return acc;
}

// Для определения версии категории(c_ и catalog/...)
const versionCategories = (list: Array<Entity.Category>) =>
  list.reduce((acc, item) => {
    item.version = isCheckCategoryVersion(item.url, 1) ? 1 : 2;

    if (item.children) {
      item.children = versionCategories(item.children);
    }

    acc.push(item);

    return acc;
  }, []);

export default class Categories implements IStoreElement {
  private ctx?: ExtendedNextPageContext;
  @observable.shallow list = [] as IObservableArray<Entity.MainCategory>;
  flatObjectByPath = {};
  flatObjectBySlug = {};

  constructor() {
    makeObservable(this);
  }

  toJSON() {
    return { list: toJS(this.list) };
  }

  @action
  hydrate(data: { list: Array<Entity.MainCategory> }): void {
    if (data.list && Array.isArray(data.list)) {
      this.set(data.list);
    }
  }

  @action
  async fetch(): Promise<void> {
    const { data, errors } = await this.ctx.api.methods.catalog.categories({
      regionID: this.ctx.store.location.regionID,
    });

    if (data) {
      this.set(data.categories || []);
    }
    if (errors) {
      throw new Error(JSON.stringify(errors));
    }
  }

  set(list: Array<Entity.Category>): void {
    const newList = versionCategories(list);
    this.list = [...newList] as IObservableArray<Entity.MainCategory>;
    this.flatObjectByPath = toFlatObject(this.list);
    this.flatObjectBySlug = toFlatObject(this.list, undefined, "alias");
  }

  /**
   * @deprecated
   * @param idsPath
   */
  getCategoryByIdsPath(
    idsPath: Entity.Category["path"]
  ): Entity.Category | undefined {
    if (!idsPath) return;
    return this.flatObjectByPath[idsPath];
  }

  /**
   * @deprecated
   * @param slug
   */
  getCategoryBySlug(
    slug: Entity.Category["alias"]
  ): Entity.Category | undefined {
    if (!slug) return;
    return this.flatObjectBySlug[slug];
  }
}
